import styled, { css } from 'styled-components';

export const TagDescriptionContainer = styled.div<{ isTooltip: boolean }>`
  display: flex;
  align-items: center;
  margin: 0 1px;
  width: 100%;
  height: var(--cl-space-7);
  text-align: center;
  border-radius: var(--cl-radius-1);
  font-size: var(--cl-font-size-1);
  font-family: var(--cl-font-family-default);
  gap: var(--cl-space-2);

  ${({ isTooltip }) => isTooltip && css`
    height: var(--cl-space-5);
    margin-bottom: var(--cl-space-1);
    margin-left: -5px;
  `}
`;

export const InfoIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 1px;
  width: var(--cl-space-5);
  height: var(--cl-space-7);
`;
